import React, {ReactNode, useEffect} from "react";
import Footer from "./Footer";
import Header from "./Header";
import ErrorMessageList from "../components/messages/ErrorMessageList";
import {ToastContainer, Zoom} from "react-toastify";
import {isNotEmpty} from "../utils/CommonUtil";
import {useNavigate} from "react-router-dom";
import {isSessionTimeError} from "../const/ErrorMessageConst";

interface MetaProps{
    title?: string;
    description?: string;
}
interface LayoutProps{
    page_meta?: MetaProps;
    children: ReactNode;
    breadcrumb_list?: string[];
    error_list?: string[];
    show_footer?: boolean;
    page_class?: string;
    handleClickUpdateOrder?: () => void | undefined;
}

const Layout: React.FC<LayoutProps> = ({
    page_meta = {},
    children,
    breadcrumb_list = [],
    error_list= [], show_footer = false, page_class = "",
    handleClickUpdateOrder = undefined,

}) => {
    const navigate = useNavigate();
    useEffect( () => {
        if(isNotEmpty(error_list)){
            if(isSessionTimeError(error_list[0])){
                navigate("/login?ec=" + error_list[0]);
            }else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
    }, [error_list]);
    useEffect(() => {
        if(page_meta){
            // @ts-ignore
            document.title = page_meta.title;
        }else{
            document.title = "ギフトアレンジ | geeva";
        }
    }, [page_meta]);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return(
        <div className="container-fluid">
            <div className="row gx-0">
                <div className="col-12 text-center">
                    <Header breadcrumb_list={breadcrumb_list}
                            handleClickUpdate={handleClickUpdateOrder}></Header>
                </div>
                <div className="col-12 text-center">
                    <div id="main-layout" className={page_class}>
                        <ErrorMessageList error_list={error_list}></ErrorMessageList>
                        {children}
                    </div>
                </div>
                {show_footer && <div className="col-12 text-center">
                    <Footer></Footer>
                </div>}
            </div>
            <section>
                <ToastContainer position="top-center"
                                autoClose={3000}
                                className="toast-center"
                                hideProgressBar={false}
                                newestOnTop={false}
                                closeOnClick={false}
                                rtl={false}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                                theme="dark"
                                transition={Zoom}></ToastContainer>
            </section>
        </div>

    );
};
export default Layout;